/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedFAQAnswer_answer = {
    readonly serviceId: string;
    readonly text: string | null;
    readonly formattedCreatedDate: string | null;
    readonly author: {
        readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQAuthor_author">;
    } | null;
    readonly " $refType": "BuySharedFAQAnswer_answer";
};
export type BuySharedFAQAnswer_answer$data = BuySharedFAQAnswer_answer;
export type BuySharedFAQAnswer_answer$key = {
    readonly " $data"?: BuySharedFAQAnswer_answer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQAnswer_answer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedFAQAnswer_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedCreatedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedFAQAuthor_author"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerType",
  "abstractKey": null
};
(node as any).hash = '4a7c48669429eb69361e85d77b79fa76';
export default node;
